import FAQ from '@/app/FAQ'

export default FAQ
